module.exports = __webpack_public_path__ + "static/media/mascote-minnie@2x.6e263439.jpg";